
export const queryParamsToLookFor = [
    {
        qProperty: 'payment_intent',
        allSelectors: [
            { qSelector: 'payment_intent', dep: false }
        ]
    },
    {
        qProperty: 'payment_method_id',
        allSelectors: [
            { qSelector: 'payment_method_id', dep: false }
        ]
    },
    {
        qProperty: 'paymethod_type',
        allSelectors: [
            { qSelector: 'paymethod_type', dep: false }
        ]
    },
    {
        qProperty: 'redirect_status',
        allSelectors: [
            { qSelector: 'redirect_status', dep: false }
        ]
    },
    {
        qProperty: 'postcode',
        allSelectors: [
            { qSelector: 'postCode', dep: true },
            { qSelector: 'postcode', dep: false }
        ]
    },
    {
        qProperty: 'address_line_one',
        allSelectors: [
            { qSelector: 'address_line_one', dep: false }
        ]
    },
    {
        qProperty: 'address_line_two',
        allSelectors: [
            { qSelector: 'address_line_two', dep: false }
        ]
    },
    {
        qProperty: 'country',
        allSelectors: [
            { qSelector: 'country', dep: false }
        ]
    },
    {
        qProperty: 'special_source',
        allSelectors: [
            { qSelector: 'special_source', dep: false }
        ]
    },
    {
        qProperty: 'promo_deal',
        allSelectors: [
            { qSelector: 'promo_deal', dep: false }
        ]
    },
    {
        qProperty: 'voucher',
        allSelectors: [
            { qSelector: 'promo_code', dep: true },
            { qSelector: 'promocode', dep: true },
            { qSelector: 'voucher', dep: false }
        ]
    },
    {
        qProperty: 'gateway',
        allSelectors: [
            { qSelector: 'gateway', dep: false }
        ]
    },
    {
        qProperty: 'service_id',
        allSelectors: [
            { qSelector: 'serviceId', dep: true },
            { qSelector: 'service_id', dep: false },
            { qSelector: 'obfServiceId', dep: true }
        ]
    }, {
        qProperty: 'cross_token',
        allSelectors: [
            { qSelector: 'cross_token', dep: false }
        ]
    },
    {
        qProperty: 'profile_id',
        allSelectors: [
            { qSelector: 'profile', dep: true },
            { qSelector: 'profile_id', dep: false }
        ]
    },
    {
        qProperty: 'profile',
        allSelectors: [
            { qSelector: 'profile', dep: false }
        ]
    },
    {
        qProperty: 'booking_transaction_id',
        allSelectors: [
            { qSelector: 'booking_transaction_id', dep: false }
        ]
    },
    {
        qProperty: 'cross_id',
        allSelectors: [
            { qSelector: 'cross_id', dep: false }
        ]
    },
    {
        qProperty: 'return_url',
        allSelectors: [
            { qSelector: 'return_url', dep: false }
        ]
    },
    {
        qProperty: 'click_id',
        allSelectors: [
            { qSelector: 'clickId', dep: true },
            { qSelector: 'click_id', dep: false }
        ]
    },
    {
        qProperty: 'free_quote',
        allSelectors: [
            { qSelector: 'free_quote', dep: false }
        ]
    },
    { 
        qProperty: 'campaign_phone',
        allSelectors: [
            { qSelector: 'fs_payload[campaign_phone]', dep: false}
        ]
    },
    { 
        qProperty: 'campaign_id',
        allSelectors: [
            { qSelector: 'fs_payload[campaign_id]', dep: false}
        ]
    },
    { 
        qProperty: 'lang',
        allSelectors: [
            { qSelector: 'fs_payload[lang]', dep: false}
        ]
    },
    { 
        qProperty: 'campaign_abbr',
        allSelectors: [
            { qSelector: 'fs_payload[campaign_abbr]', dep: false}
        ]
    },
    { 
        qProperty: 'utm_id',
        allSelectors: [
            { qSelector: 'utm_id', dep: false}
        ]
    },
    {
        qProperty: 'utm_source',
        allSelectors: [
            { qSelector: 'utm_source', dep: false}
        ]
    },
    {
        qProperty: 'utm_medium',
        allSelectors: [
            { qSelector: 'utm_medium', dep: false}
        ]
    },
    {
        qProperty: 'utm_campaign',
        allSelectors: [
            { qSelector: 'utm_campaign', dep: false}
        ]
    },
    {
        qProperty: 'utm_term',
        allSelectors: [
            { qSelector: 'utm_term', dep: false}
        ]
    },
    {
        qProperty: 'utm_content',
        allSelectors: [
            { qSelector: 'utm_content', dep: false}
        ]
    },
    { 
        qProperty: 'authorization',
        allSelectors: [
            { qSelector: 'fs_payload[authorization]', dep: false}
        ]
    },
    { 
        qProperty: 'exit_position',
        allSelectors: [
            { qSelector: 'fs_payload[exit_position]', dep: false}
        ]
    },
    {
        qProperty: 'covering_postcode',
        allSelectors: [
            { qSelector: 'fs_payload[covering_postcode]', dep: false}
        ]
    },
    {
        qProperty: 'fs_payload[*]',
        allSelectors: [
            { qSelector: 'fs_payload', dep: false }
        ]
    },
    {
        qProperty: 'utp[*]',
        allSelectors: [
            { qSelector: 'utp', dep: false }
        ]
    },
    {
        qProperty: 'fs_item_prefill[*]',
        allSelectors: [
            { qSelector: 'fs_item_prefill', dep: false }
        ]
    },
    {
        qProperty: 'regular_plan_id',
        allSelectors: [
            { qSelector: 'fs_payload[regular_plan_id]', dep: false},
            { qSelector: 'payload[regular_plan_id]', dep: false}
        ]
    },
    {
        qProperty: 'screen',
        allSelectors: [
            { qSelector: 'fs_screen', dep: false},
            { qSelector: 'screen', dep: false}
        ]
    },
    {
        qProperty: 'element_id',
        allSelectors: [
            { qSelector: 'fs_element_id', dep: false},
            { qSelector: 'element_id', dep: false}
        ]
    },
    {
        qProperty: 'action',
        allSelectors: [
            { qSelector: 'fs_action', dep: false},
            { qSelector: 'action', dep: false}
        ]
    }
];
